<div class="relative tag-selector-container"
  #tagSelectorContainer
  (click)="toggleDropdown($event)">

  <label class="block text-sm font-medium tags-label">{{ isMultiple ? 'Etiquetas' : 'Etiqueta' }}</label>
  <div class="tags-input" [class.is-single]="!isMultiple" [class.is-empty]="selectedTags.length === 0">
    <div class="tags-selection">
      @for (tag of selectedTags; track tag) {
        <span
                  [ngStyle]="{
                    'background-color': tag.color,
                    'color': '#fff'
                  }"
          class="tag-chip">
          {{ tag.name }}
          <button
            (click)="removeTag(tag.id); $event.stopPropagation()"
            class="tag-chip__remove"
            [style.color]="'#fff'"
            >
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }

      @if (selectedTags.length === 0) {
        <span class="tags-placeholder">
          {{ isMultiple ? 'Selecionar etiquetas' : 'Selecionar etiqueta' }}
        </span>
      }
    </div>

    <div class="tags-input__meta">
      @if (isMultiple && selectedTags.length > 0) {
        <span class="tags-count">{{ selectedTags.length }} selecionadas</span>
      }
      <mat-icon>expand_more</mat-icon>
    </div>
  </div>
</div>

<ng-template #dropdownTemplate>
  <div class="tags-dropdown">
    <div class="tags-dropdown__header">
      <strong>{{ isMultiple ? 'Etiquetas' : 'Selecionar etiqueta' }}</strong>
      <span>{{ isMultiple ? 'Escolhe e organiza as etiquetas disponíveis.' : 'Só pode estar uma etiqueta selecionada.' }}</span>
    </div>

    <div class="tags-dropdown__composer">
      <input [(ngModel)]="newTagName"
        class="tags-dropdown__name-input"
        placeholder="Nova etiqueta" />
      <label class="tags-dropdown__color-field" aria-label="Escolher cor">
        <input [(ngModel)]="newTagColor"
          type="color"
          class="tags-dropdown__color-input" />
      </label>
      <button
        type="button"
        mat-icon-button
        (click)="createNewTag()"
        [disabled]="!newTagName?.trim()"
        class="tags-dropdown__add-button">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div cdkDropList
      (cdkDropListDropped)="drop($event)"
      class="tags-dropdown__list">
      @for (tag of tags; track tag; let i = $index) {
        <div
          cdkDrag
          (click)="addTag(tag)"
          class="tags-dropdown__item"
          [class.is-selected]="isTagSelected(tag.id)">
          <button
            type="button"
            class="tags-dropdown__drag"
            cdkDragHandle
            (click)="$event.stopPropagation()">
            <mat-icon>drag_indicator</mat-icon>
          </button>
          <span
                    [ngStyle]="{
                        'background-color': tag.color,
                        'color': getContrastColor(tag.color)
                    }"
            class="tags-dropdown__item-chip">
            {{ tag.name }}
          </span>
          <button mat-icon-button
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            class="tags-dropdown__item-menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu>
            <div mat-menu-item class="flex items-center"
              (click)="$event.stopPropagation()">
              <mat-icon>edit</mat-icon>
              <input [(ngModel)]="tag.name"
                (focus)="startEditing(tag)"
                (blur)="updateTagName(tag)"
                class="tags-dropdown__menu-input"
                placeholder="Editar Nome"
                #tagInput>
            </div>
            <button mat-menu-item (click)="deleteTag(tag)">
              <mat-icon>delete</mat-icon> Remover
            </button>
            <div mat-menu-item class="flex items-center">
              <mat-icon>palette</mat-icon> Cor
              <input type="color"
                [(ngModel)]="tag.color"
                (click)="$event.stopPropagation()"
                (change)="updateTagColor(tag)"
                class="tags-dropdown__menu-color">
            </div>
          </mat-menu>
        </div>
      }
    </div>
  </div>
</ng-template>
